import { IStackStyles } from "@fluentui/react";

export const getBannerBreadcrumbTitleColumnStyles = (): IStackStyles => {
    return {
        root: {
            paddingTop: "18px",
            paddingBottom: "24px"
        }
    };
};
